<script setup lang="ts">
import { markRaw, shallowRef, watchEffect } from 'vue'
import draggable from 'vuedraggable'

interface ComponentItem {
  id: string
  component: any
  props?: Record<string, any>
  events?: Record<string, any>
}

const props = defineProps<{
  components: ComponentItem[]
}>()

const emit = defineEmits<{
  (e: 'update:components', components: ComponentItem[]): void
}>()

const localComponents = shallowRef<ComponentItem[]>([])

watchEffect(() => {
  localComponents.value = props.components.map(item => ({
    ...item,
    component: markRaw(item.component)
  }))
})

const updateComponents = (event: any) => {
  if (event.moved || event.added || event.removed) {
    emit('update:components', localComponents.value)
  }
}
</script>

<template>
  <div class="w-full">
    <draggable
      v-model="localComponents"
      class="grid grid-cols-1 lg:grid-cols-12 gap-4"
      :item-key="(item: ComponentItem) => item.id"
      handle=".drag-handle"
      @change="updateComponents"
    >
      <template #item="{ element }">
        <div
          :class="[
            element.props?.column === 12
              ? 'col-span-12'
              : `col-span-${element.props?.column || 12}`,
          ]"
        >
          <component :is="element.component" v-bind="element.props" v-on="element.events || {}">
            <template v-for="name in $slots" :key="name" #[name]="slotData">
              <slot :name="name" v-bind="slotData" />
            </template>
          </component>
        </div>
      </template>
    </draggable>
  </div>
</template>